import { routes } from '@/routes/routes';
import { UserFollow as UserFollowIcon } from '@carbon/icons-react';
import { Link, useLocation, useSearch } from '@tanstack/react-router';
import { Button } from '../common/Button';
import { HeaderWrapper } from '../layout/HeaderWrapper';

export const AuthHeader = () => {
  const location = useLocation();
  const search = useSearch({ strict: false });

  const isLogin = location.pathname === routes.auth.login;
  const isDoctor = 'type' in search && search.type === 'doctor';

  return (
    <HeaderWrapper
      desktopContent={
        isLogin ? (
          !isDoctor ? (
            <Button variant="secondary" animate asChild>
              <Link to={routes.auth.register}>
                <UserFollowIcon className="size-6" /> <p>Sign up</p>
              </Link>
            </Button>
          ) : undefined
        ) : (
          <Button variant="secondary" asChild>
            <Link to={routes.auth.login}>Login</Link>
          </Button>
        )
      }
    />
  );
};
